import { render } from "./CheckboxView.vue?vue&type=template&id=2a9e9fb2&scoped=true"
import script from "./CheckboxView.vue?vue&type=script&lang=js"
export * from "./CheckboxView.vue?vue&type=script&lang=js"

import "./CheckboxView.vue?vue&type=style&index=0&id=2a9e9fb2&scoped=true&lang=css"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9e9fb2"]])

export default __exports__